<template>
  <div
    class="content-use-guide-web"
    v-html="$t('owork_base.owork_user_guide.content_web', { OSField, brand, OSVersion, applicationVersion })"
  ></div>
</template>

<script lang="ts" setup>
  import { useSharedBrand } from '@/core/compositions/UseBrand'

  const { OSField, brand, OSVersion, applicationVersion } = useSharedBrand()
</script>

<style lang="stylus">
  .content-use-guide-web
    & > p
      line-height 20px
    & > .content-title:first-child
      margin-top 14px
    .content-title
      margin-top 24px
      title()
    .content-desc
      margin-top 6px
      sub-title()

  @import '../../styles/h5Adaptive/settingModal.styl'
</style>
